/**
 * TanStack Query keys. Everything scoped to one server lives under ['server', serverId], so a removed server's
 * queries can be dropped with one prefix.
 */
export const queryKeys = {
  session: ['session'] as const,
  servers: ['servers'] as const,
  serverScope: (serverId: string) => ['server', serverId] as const,
  server: (serverId: string) => ['server', serverId, 'detail'] as const,
  plugins: (serverId: string) => ['server', serverId, 'plugins'] as const,
  resource: (serverId: string, resourceId: string) =>
    ['server', serverId, 'resource', resourceId] as const,
  resources: (serverId: string) => ['server', serverId, 'resource'] as const,
  materials: (serverId: string) => ['server', serverId, 'materials'] as const,
  audit: (serverId: string) => ['server', serverId, 'audit'] as const,
};
